import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProtectedRoute } from './Components/ProtectedRoutes/ProtectedRoutes';
import { UserRole } from './api/users';
import { PublicRoute } from './Components/PublicRoute/PublicRoute';
import { SignIn } from './Pages/SignIn/SignIn';
import { ForgotPassword } from './Pages/ForgotPassword/ForgotPassword';
import { NotFound } from './Pages/NotFound/NotFound';
import { AlertProvider } from './contexts/AlertContext';
import { LoaderProvider } from './contexts/LoaderContext';
import { Users } from './Pages/Users/Users';
import { Resources } from './Pages/Resources/Resources';

import { Merch } from './Pages/Merch/Merch';
import { Events } from './Pages/Events/Events';
import { EventDetailsPage } from './Pages/Events/EventDetailsPage';
import { Leaderboard } from './Pages/Leaderboard/Leaderboard';
import { Modules } from './Pages/Modules/Modules';

import './App.scss';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AdminLeaderboard } from './Pages/AdminLeaderboard/AdminLeaderboard';
import { AdminResults } from './Pages/AdminResults/AdminResults';
import { Results } from './Pages/Results/Results';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <LoaderProvider>
        <AlertProvider>
          <Router>
            <AuthProvider>
              <Routes>
                <Route
                  path="/signin"
                  element={
                    <PublicRoute>
                      <SignIn />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/forgot-password"
                  element={
                    <PublicRoute>
                      <ForgotPassword />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <RootPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <ProtectedRoute>
                      <Users />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/resources"
                  element={
                    <ProtectedRoute>
                      <Resources />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/merch"
                  element={
                    <ProtectedRoute>
                      <Merch />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/events"
                  element={
                    <ProtectedRoute>
                      <Events />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/events/:id"
                  element={
                    <ProtectedRoute>
                      <EventDetailsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/leaderboard"
                  element={
                    <ProtectedRoute>
                      <LeaderboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modules"
                  element={
                    <ProtectedRoute>
                      <Modules />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/results"
                  element={
                    <ProtectedRoute>
                      <ResultsPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AuthProvider>
          </Router>
        </AlertProvider>
      </LoaderProvider>
    </LocalizationProvider>
  );
}

const RootPage = () => {
  return <Modules />;
};

const LeaderboardPage = () => {
  const { userData } = useAuth();
  const isAdmin = userData?.role === UserRole.ADMIN || userData?.role === UserRole.DIRECTOR;
  return isAdmin ? <AdminLeaderboard /> : <Leaderboard />;
};

const ResultsPage = () => {
  const { userData } = useAuth();
  const isAdmin = userData?.role === UserRole.ADMIN || userData?.role === UserRole.DIRECTOR;
  return isAdmin ? <AdminResults /> : <Results />;
};

export default App;
